<template>
    <div class="setPlantParams">
        <div class="formItem">
            <label>二氧化碳折算系数</label>
            <input type="text" v-show="!canEdit" v-model="plantParams.carbonValue" placeholder = "" disabled />
            <input type="text" v-show="canEdit" v-model="plantParams.carbonValue" placeholder = "" />
        </div>
        <div class="formItem">
            <label>二氧化硫折算系数</label>
            <input type="text" v-show="!canEdit" v-model="plantParams.sulfurValue" placeholder = "" disabled />
            <input type="text" v-show="canEdit" v-model="plantParams.sulfurValue" placeholder = "" />
        </div>
        <div class="formItem">
            <label>光伏列阵面积</label>
            <input type="text" v-show="!canEdit" v-model="plantParams.gfmianji" placeholder = "" disabled />
            <input type="text" v-show="canEdit" v-model="plantParams.gfmianji" placeholder = "" />
        </div>
        <div class="formItem">
            <label>辐照</label>
            <input type="text" v-show="!canEdit" v-model="plantParams.fuzhao" placeholder = "" disabled />
            <input type="text" v-show="canEdit" v-model="plantParams.fuzhao" placeholder = "" />
        </div>
        <div class="formItem">
            <label>倾斜角</label>
            <input type="text" v-show="!canEdit" v-model="plantParams.qingxiejiao" placeholder = "" disabled />
            <input type="text" v-show="canEdit" v-model="plantParams.qingxiejiao" placeholder = "" />
        </div>

        <div class="btnsArea">
            <button v-show="!canEdit" @click="canEdit = true">编辑</button>
            <button v-show="canEdit" @click="canEdit = false">取消</button>
            <button v-show="canEdit" @click="savePlantParams">保存</button>
        </div>
    </div>
</template>

<script>
        export default {
            data() {
                return {
                    canEdit:false,
                    plantParams: {
                        carbonValue:0,//二氧化碳
                        sulfurValue:0,//二氧化硫
                        gfmianji:0,//光伏面积
                        gfzhujian:0,//光伏组件数量
                        fuzhao:0,//辐照
                        qingxiejiao:0//倾斜角
                    },
                }
            },
            computed: {
                nowUnit() {
                    return this.$store.unitStore.getters.getNowUnit
                },
            },
            watch: {
                nowUnit() {
                    this.getPlantParams();
                }
            },
            mounted() {
                this.getPlantParams();
            },
            methods: {
                getPlantParams() {
                    //清空
                    this.plantParams = {
                        carbonValue:0,//二氧化碳
                        sulfurValue:0,//二氧化硫
                        gfmianji:0,//光伏面积
                        gfzhujian:0,//光伏组件数量
                        fuzhao:0,//辐照
                        qingxiejiao:0//倾斜角
                    };
                    this.$api.plantApi.getPlantParams(this.nowUnit.id,res => {
                        if(!isempty(res)) {
                            this.plantParams.carbonValue = res.carbon;
                            this.plantParams.sulfurValue = res.sulfur;
                            this.plantParams.gfmianji = res.gfMianji;
                            this.plantParams.gfzhujian = res.gfZhujian;
                            this.plantParams.fuzhao = res.fuzhao;
                            this.plantParams.qingxiejiao = res.qingxiejiao;
                        }
                    })

                },
                savePlantParams() {
                    this.$api.plantApi.savePlantParams(this.nowUnit.id,this.plantParams.carbonValue,this.plantParams.sulfurValue,
                        this.plantParams.gfmianji,this.plantParams.gfzhujian,this.plantParams.fuzhao,this.plantParams.qingxiejiao, res => {
                        this.canEdit = false
                        this.$dialogMethod.showMessage('保存成功！')
                        // this.getPlantParams();
                    },err =>{
                            this.$dialogMethod.showMessage(err)
                        }
                        )
                }
            }
        }
</script>

<style scoped>
    .setPlantParams {
        height: calc(100% - 40px);
        background-color: #FFFFFF;
        padding: 20px;
        position: relative;
    }
    .formItem {
        margin-bottom: 12px;
    }

    .formItem>label {
        min-width: 120px;
        text-align: right;
        display: inline-block;
        margin-right: 12px;
        line-height: 32px;
    }

    .formItem>input {
        width: 295px;
        height: 26px;
    }
    .formItem>label>span {
        display: inline-block;
        width: 8px;
    }
    .btnsArea {
        position: absolute;
        width: calc(100% - 40px);
        bottom: 450px;
        text-align: center;
    }

    .btnsArea>button {
        color: #FFFFFF;
        background-color: #409EFF;
        border-radius: 4px;
        height: 36px;
        padding: 0 12px;
        margin: 0 10px;
    }
</style>